module.exports = __webpack_public_path__ + "static/media/PAN.347cc7b8.svg";